// extracted by mini-css-extract-plugin
module.exports = {"title":"no_chip_in__title___1kMRw _type__vx_text-2___Qizsf","subtitle":"no_chip_in__subtitle___1IYxe","ok-button":"no_chip_in__ok-button___4uxsp"};